<div class="container">
    <div class="row align-items-center justify-content-sm-center">
        <div class="col-md-3 hidden-md">
            <img src="assets/images/common/general-error/penguins1-no-shadow.png" class="turtle" alt="" />
        </div>

        <div class="col-md-9">
            <div class="st-description">
                <h1>Oops!</h1>
                @if(not_found){
                    <div class="st-not-found">
                        <h2><strong>404</strong> Page not found</h2>
                        <p>The page you are looking for does not exist on this server</p>
                    </div>
                }
                @else{
                    <div class="st-error">
                        <h2>looks like something went completely wrong.</h2>
                        @if(error_title != undefined && error_title.length > 0){
                            <div class="st-error-info">
                                <h4 class="st-error-title">Error - {{error_title}}</h4>
                                    @if(error_description != undefined && error_description.length > 0){
                                        <p class="st-error-message">{{error_description}}</p>
                                    }
                                    @else if(error_message != undefined && error_message.length > 0){
                                        <p class="st-error-message">{{error_message}}</p>
                                    }
                            </div>
                        }
                    </div>
                }
                <p>Please try redirecting to <a href="/">mainpage</a>. If the problem persists contact us.</p>
            </div>
        </div>
    </div>
</div>
